import { Callout } from "@clipboard-health/ui-components";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { useFavoriteWorkplaces } from "@src/appV2/Workplaces/api/useFavoriteWorkplaces";
import { useHistory } from "react-router-dom";

import { useFavoriteWorkplacesOpenShiftsCount } from "../ShiftDiscovery/FavoriteWorkplaces/useFavoriteWorkplacesOpenShiftsCount";
import { SHIFT_DISCOVERY_FAVORITE_WORKPLACES_FULL_PATH } from "../ShiftDiscovery/paths";

export function FavoriteWorkplacesCallout() {
  const history = useHistory();
  const {
    favoriteWorkplacesOpenShiftsCount,
    isLoading: isFavoriteWorkplacesOpenShiftsCountLoading,
  } = useFavoriteWorkplacesOpenShiftsCount();
  const { favoriteWorkplacesCount, isLoading } = useFavoriteWorkplaces();

  /**
   * If the favorite workplaces api is loading, we will not show the callout
   * If favoriteWorkplacesCount is 0, we will not show the callout
   * If the count is loading, we will not show the callout
   * If the count is greater than 0, we will not show the callout
   */
  if (
    isLoading ||
    isFavoriteWorkplacesOpenShiftsCountLoading ||
    favoriteWorkplacesOpenShiftsCount > 0 ||
    favoriteWorkplacesCount === 0
  ) {
    return null;
  }

  return (
    <Callout
      aria-label="View Favorite Workplaces"
      title="No favorite workplace shifts"
      iconType="like-filled"
      sx={(theme) => ({
        background: theme.palette.favoriteWorkplaces?.background,
        color: theme.palette.text.primary,
      })}
      onClick={() => {
        logEvent(APP_V2_USER_EVENTS.OPEN_SHIFTS_CALLOUT_VIEWED, {
          type: "favoriteWorkplaces",
          count: favoriteWorkplacesCount,
        });
        history.push(SHIFT_DISCOVERY_FAVORITE_WORKPLACES_FULL_PATH);
      }}
    />
  );
}
